import LocationOffIcon from '@mui/icons-material/LocationOff';
import React from "react";
import { Outer, Header, Title, IconCircle, Copy } from "./styled";

export const Skeleton = () => {
    return (
        <Outer>
            <Header>
                <IconCircle>
                    <LocationOffIcon fontSize="large" />
                </IconCircle>
                <Title>No results found for your suburb</Title>
            </Header>

            <Copy>
                We weren’t able to find any services for your suburb. Check below for support available in your region
            </Copy>
        </Outer>
    );
};
